module.exports = __webpack_public_path__ + "img/PeopleOutlineFilled.3d708740.svg";